import * as z from "zod";

export const getCanonicalLocationsInput = z.object({});

const CanonicalLocationSchema_ = z.object({
  name: z.string(),
  externalId: z.string(),
});
export const CanonicalLocationSchema: z.ZodType<CanonicalLocation> =
  CanonicalLocationSchema_;
export interface CanonicalLocation
  extends z.infer<typeof CanonicalLocationSchema_> {}

export const getCanonicalLocationsOutput = z.object({
  locations: z.array(CanonicalLocationSchema),
});

export const getCanonicalLocations = {
  name: "getCanonicalLocations" as const,
  input: getCanonicalLocationsInput,
  output: getCanonicalLocationsOutput,
};
